// RF-DEL-01/05: what the delete_project card's click removes — the project's name and task counts, loaded from the API
// (never from the model), and the note that the linked GitHub repository is not deleted.
import { useEffect, useState } from "react";
import { useI18n } from "../../i18n/index.tsx";
import { getProjectDeletion, type ProjectDeletionFacts } from "../../api/endpoints.ts";

export function DeleteProjectFacts({ projectId }: { projectId: string }) {
  const { t } = useI18n();
  const [facts, setFacts] = useState<ProjectDeletionFacts | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let live = true;
    getProjectDeletion(projectId).then(
      (f) => live && setFacts(f),
      () => live && setFailed(true),
    );
    return () => {
      live = false;
    };
  }, [projectId]);
  return (
    <div data-testid="assistant-delete-project">
      {facts ? (
        <>
          <p className="assistant-note user-content">{t("projectDelete.summary", { name: facts.name, total: facts.task_counts.total, done: facts.task_counts.done, cancelled: facts.task_counts.cancelled, inProgress: facts.task_counts.in_progress })}</p>
          {!facts.deletable ? <p className="assistant-note">{t("projectDelete.runningWork")}</p> : null}
        </>
      ) : failed ? (
        <p className="assistant-note">{t("projectDelete.factsUnavailable")}</p>
      ) : null}
      <p className="assistant-note">{t("projectDelete.repositoryKept")}</p>
    </div>
  );
}
